import Reviews from "../components/Reviews";


const ReviewsView = () => {

    return (
        <div className="reviews">
            <Reviews/>
        </div>
    );
};

export default ReviewsView;
